import React from 'react'
import Link from 'next/link'

interface RequestPasswordResetFormProps {
	onFormSubmit: Function
	error: any
}

interface RequestPasswordResetFormState {
	email: string
}

class RequestPasswordResetForm extends React.Component<
	RequestPasswordResetFormProps,
	RequestPasswordResetFormState
> {
	constructor(props: RequestPasswordResetFormProps) {
		super(props)
		this.state = {
			email: '',
		}

		this.handleInputChange = this.handleInputChange.bind(this)
		this.handleSubmit = this.handleSubmit.bind(this)
	}

	handleInputChange(event: React.FormEvent<HTMLInputElement>) {
		const target = event.target as HTMLInputElement
		const value = target.value
		const name = target.name

		this.setState({
			[name]: value,
		} as Pick<RequestPasswordResetFormState, keyof RequestPasswordResetFormState>)
	}

	handleSubmit(e: React.FormEvent<HTMLFormElement>) {
		e.preventDefault()
		this.props.onFormSubmit(this.state)
	}

	render() {
		return (
			<form onSubmit={this.handleSubmit} className="px-8 pt-6 pb-8 mb-4">
				<div className="mb-4">
					<label
						className="block font-sans text-purple-900 text-sm font-bold mb-2"
						htmlFor="email"
					>
						Email
					</label>
					<input
						className="w-full"
						name="email"
						value={this.state.email}
						onChange={this.handleInputChange}
						id="email"
						type="email"
						placeholder="Email"
						required
					/>
				</div>

				{this.props.error && (
					<p className="text-red-600">Email address is incorrect</p>
				)}

				<div className="flex items-center justify-between mt-4 flex-col sm:flex-row">
					<button
						className="bg-purple-900 text-white hover:bg-purple-800 mb-4 sm:mb-0"
						disabled={!this.state.email}
						type="submit"
					>
						Recover password
					</button>
					<Link href="/login">
						<a className="inline-block align-baseline font-semibold text-sm text-blue-500 hover:text-blue-600">
							Back to login
						</a>
					</Link>
				</div>
			</form>
		)
	}
}

export default RequestPasswordResetForm
